import React from 'react';
import { Image, List, Card, Loader } from 'semantic-ui-react';
import EditTextModal from '../../../../common/EditTextModal';
import { dispatch } from '@rematch/core/';
import defaultLogo from '../../../../../images/logo/logo-128.png';
import ImageResizer from '../../../../drive/ImageResizer/ImageResizer';

export default class GeneralSetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openText: false,
            imagePath: null,
            logo: props.selectedAccount.logo ? props.selectedAccount.logo : defaultLogo
        }
        this.updateText = this.updateText.bind(this);
        this.openTextModal = this.openTextModal.bind(this);
        this.submitTextModal = this.submitTextModal.bind(this)
    }
    openImageModal = (open) => {
        this.setState({ open: open })
    }

    componentWillMount() {
        dispatch.app.setCurrentContext("acc-gs-setting");
        dispatch.community.setMainAreaContext("OtherAccountSetting");
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ loader: false, logo: imageData.data.secure_url })
            dispatch.registerAccount.setAccountLogoImage(imageData.data.secure_url);
            let payload = {
                _id: this.props.selectedAccount._id,
                logo: imageData.data.secure_url
            }
            dispatch.registerAccount.UpdateAccountDetails(payload)
        }
    }
    openTextModal(e, openText) {
        this.setState({ openText: openText })
    }

    updateText(data, name) {
        this.setState({ name: data })
    }

    submitTextModal() {
        this.setState({ openText: false })
        let data = {
            name: this.state.name,
            oldName: this.props.selectedAccount.name
        }
        dispatch.account.updateAccountDetails({ accountId: this.props.selectedAccount._id, data: data })
    }

    render() {
        const { selectedAccount, accountLogoObjectCloudinary } = this.props;

        return (
            <div >
                <Card>
                    <Card.Header>General Settings</Card.Header>
                    <Card.Content className="pad_0">
                        <List divided verticalAlign='middle'>
                            <List.Item className="singleLine">
                                <List.Content floated='right'>
                                    <span className="cursor-pointer"
                                        onClick={(e) => this.openTextModal(e, true, selectedAccount.name)}
                                    >
                                        {selectedAccount.name}
                                    </span>
                                </List.Content>
                                <List.Content >
                                    <List.Header >Account Name</List.Header>
                                </List.Content>
                            </List.Item>
                            <List.Item className="singleLine">
                                <List.Content floated='right'>
                                    <Loader inline size='mini' active={this.state.loader} />
                                    {this.state.loader ? null :
                                        <Image
                                            src={this.state.logo}
                                            onClick={this.openImageModal}
                                            className="cursor-pointer h_24" />
                                    }
                                </List.Content>
                                <List.Content >
                                    <List.Header >Account Logo</List.Header>
                                </List.Content>
                            </List.Item>

                        </List>
                    </Card.Content>
                </Card>

                <ImageResizer
                    user={this.props.user}
                    image={this.state.logo}
                    openImageModal={this.openImageModal}
                    cloudinaryImage={this.cloudinaryImage}
                    open={this.state.open}
                    accountData={selectedAccount}
                    accountLogoObjectCloudinary={accountLogoObjectCloudinary}
                    width={180}
                    height={108}
                    envData={this.props.envData}
                />
                <EditTextModal
                    open={this.state.openText}
                    openTextModal={this.openTextModal}
                    submitTextModal={this.submitTextModal}
                    name="Name"
                    text={selectedAccount.name}
                    onChangeText={this.updateText}
                    {...this.props}
                />
            </div>
        );
    }
}

